import React, { Component } from "react";
import numeral from "numeral";
import { CircleProgress } from "reactackle";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PhotoCard from "./PhotoCard";
import _ from "lodash";

class BuyFromShopGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        path: this.props.tableName,
        payload: this.props.data
      },
      fieldList: {
        worker: ["mobile", "name", "address", "requestedItems"],
        grocer: ["mobile", "name", "requestedItems"],
        all: [
          "deliveryDate",
          "mobile",
          "name",
          "address",
          "requestedItems",
          "status",
          "supplier",
          "supplierPrice",
          "supplierNotes",
          "supplierPrices"
        ]
      }
    };
  }

  componentDidMount() {
    this.props.loadPrevOrders();
  }

  getPhotos = photos => {
    if (photos && photos.length > 0) {
      return photos.map((photo, index) => {
        if (photo.status === "DONE") {
          return (
            <div style={{ backgroundColor: "white" }}>
              <LazyLoadImage src={photo.url} style={{ minHeight: "200px" }} />
            </div>
          );
        } else {
          return (
            <div style={{ padding: "40px", backgroundColor: "white" }}>
              <CircleProgress
                indeterminate
                subtitle="Updating..."
                labelPositionX={"center"}
                labelPositionY={"bottom"}
              />
            </div>
          );
        }
      });
    }
  };

  getBucketView = rec => {
    let bucketDets = this.props.getBucketDetails(rec);
    if (bucketDets) {
      return (
        <div
          style={{
            borderRadius: "5px",
            color: "black",
            backgroundColor: "white",
            fontSize: "18px",
            border: "0px solid rgb(30, 101, 144)",
            cursor: "pointer",
            fontWeight: "bold",
            width: "180px",
            height: "40px",
            lineHeight: "40px",
            textAlign: "center",
            margin: "5px"
          }}
        >
          <span style={{ fontSize: "10px" }}>Units: </span>{" "}
          {bucketDets.quantity}{" "}
          <span style={{ fontSize: "10px", marginLeft: "10px" }}>SGD: </span>{" "}
          {bucketDets.amount}
        </div>
      );
    }
  };

  getCard = rec => {
    return (
      <div
        style={{
          background: "#FFFFFF",
          border: "1.5px solid #ccc",
          boxSizing: "border-box",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: "10px",
          marginBottom: "10px",
          marginRight: "5px",
          marginLeft: "5px",
          padding: "2px"
        }}
      >
        <div
          style={{
            margin: "0px",
            fontSize: "16px",
            fontWeight: "bold",
            textTransform: "uppercase",
            width: "100%",
            padding: "10px",
            paddingBottom: "0px"
          }}
        >
          {rec.productNameEnglish}
        </div>
        <div
          style={{
            marginTop: "1px"
          }}
        >
          <span
            style={{
              marginTop: "1px",
              marginBottom: "0px",
              marginLeft: "10px",
              fontSize: "16px",
              fontWeight: "bolder",
              borderRadius: "10px",
              textTransform: "uppercase",
              backgroundColor: "black",
              padding: "2px",
              color: "white",
              paddingLeft: "10px",
              paddingRight: "10px"
            }}
          >
            ${numeral(rec.productPrice).format("0,0.00")}
          </span>
          <span
            style={{
              marginTop: "1px",
              marginBottom: "0px",
              marginLeft: "1px",
              fontSize: "12px",
              textTransform: "uppercase",
              backgroundColor: "white",
              padding: "2px",
              borderRadius: "2px",
              color: "black",
              lineHeight: "16px"
            }}
          >
            {rec.unit}
          </span>
        </div>
        <div
          style={{
            marginLeft: "1px",
            marginRight: "1px"
          }}
        >
          <PhotoCard photos={rec.photos} />
        </div>

        {rec.availability !== "OUT OF STOCK, TOPPING UP IN PROGRESS" && (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center"
            }}
          >
            <span
              style={{
                width: "10%",
                minWidth: "20%"
              }}
            >
              {this.props.getBucketDetails(rec) && (
                <div
                  style={{
                    borderRadius: "40px",
                    color: "#fff",
                    backgroundColor: "red",
                    fontSize: "2em",
                    border: "0px solid black",
                    cursor: "pointer",
                    fontWeight: "bold",
                    width: "40px",
                    height: "40px",
                    lineHeight: "40px",
                    textAlign: "center",
                    margin: "5px"
                  }}
                  onClick={() => {
                    this.props.removeFromBucket(rec);
                  }}
                >
                  -
                </div>
              )}
            </span>

            <span
              style={{
                width: "80%",
                minWidth: "20%",
                display: "flex",
                justifyContent: "center"
              }}
            >
              {this.getBucketView(rec)}
            </span>

            <span
              style={{
                width: "10%",
                minWidth: "20%"
              }}
            >
              <div
                style={{
                  width: "100%",
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <div
                  style={{
                    borderRadius: "40px",
                    color: "#fff",
                    backgroundColor: "rgb(30, 101, 144)",
                    fontSize: "2em",
                    border: "0px solid black",
                    cursor: "pointer",
                    fontWeight: "bold",
                    width: "40px",
                    height: "40px",
                    lineHeight: "40px",
                    textAlign: "center",
                    margin: "5px"
                  }}
                  onClick={() => {
                    this.props.addToBucket(rec);
                  }}
                >
                  <span className="blink">+</span>
                </div>
              </div>
            </span>
          </div>
        )}
        {rec.availability === "OUT OF STOCK, TOPPING UP IN PROGRESS" && (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              textAlign: "center"
            }}
          >
            OUT OF STOCK, TOPPING UP IN PROGRESS
          </div>
        )}
      </div>
    );
  };

  getMobileDivs = data => {
    //console.log(JSON.stringify(this.props.myProductsKeys));
    return data.map(rec => {
      //console.log(rec.sortOrder + " - " + rec.category);
      if (rec && rec.productNameEnglish) {
        return this.getCard(rec);
      }
    });
  };

  getFilteredData = data => {
    //console.log(JSON.stringify(data));
    let filtRes = [];
    if (data && data.length > 0) {
      if (this.props.searchVal && this.props.searchVal !== "") {
        for (let i = 0; i < data.length; i++) {
          let rec = data[i];

          let recSearchVal = "";
          if (
            rec.searchText &&
            rec.searchText !== undefined &&
            rec.searchText !== ""
          ) {
            recSearchVal = rec.searchText;
          }

          let recVal = rec.productNameEnglish;
          let filterVal = this.props.searchVal.toLowerCase();

          let searchResult = recVal.toLowerCase().includes(filterVal);
          if (searchResult) {
            filtRes.push(rec);
          } else {
            if (recSearchVal.toLowerCase().includes(filterVal)) {
              filtRes.push(rec);
            }
          }
        }
      } else {
        filtRes = data;
      }
    }
    if (this.props.searchFilters.category === "POPULAR") {
      filtRes = _.sortBy(filtRes, "count");
      filtRes = filtRes.reverse();
      return filtRes;
    } else {
      return filtRes;
    }
  };

  getShoGrid = () => {
    //console.log(this.props.searchFilters.category);
    let filtData = [];
    if (
      this.props.searchFilters.category === "ALL" ||
      this.props.searchFilters.category === undefined
    ) {
      filtData = this.getFilteredData(this.props.db["supplierShopItems"]);
    } else {
      filtData = this.getFilteredData(
        this.props.db[this.props.searchFilters.category]
      );
    }

    if (filtData && filtData.length > 0) {
      // console.log(filtData.length);
      // console.log("got some prods");
      return <div>{this.getMobileDivs(filtData)}</div>;
    } else {
      console.log("time to ask for customer product");
      return (
        <div
          style={{
            margin: "10px",
            textAlign: "center"
          }}
        >
          <div>No products matched your search criteria</div>
        </div>
      );
    }

    //return this.getRows(this.props.data);
  };

  render() {
    return <div style={{ marginTop: "30px" }}>{this.getShoGrid()}</div>;
  }
}

export default BuyFromShopGrid;



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/BuyFromShopGrid.jsx